import { render } from "./detailsPage.vue?vue&type=template&id=0c2cce50&scoped=true"
import script from "./detailsPage.vue?vue&type=script&lang=js"
export * from "./detailsPage.vue?vue&type=script&lang=js"

import "./detailsPage.vue?vue&type=style&index=0&id=0c2cce50&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2cce50"]])

export default __exports__